import { render, staticRenderFns } from "./ResultadoFactura.vue?vue&type=template&id=153103fa&scoped=true"
import script from "./ResultadoFactura.vue?vue&type=script&lang=js"
export * from "./ResultadoFactura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153103fa",
  null
  
)

export default component.exports